import React, { Component } from 'react';

import './index.css';

class FormInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideLabel: true,
    };

    this.input = React.createRef();
    this._onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { onChange } = this.props;
    const value = event.target.value.trim();

    if (value.length > 0) {
      this.showLabel();
    } else {
      this.hideLabel();
    }

    onChange(event);
  }

  hideLabel() {
    this.setState({ hideLabel: true });
  }

  showLabel() {
    this.setState({ hideLabel: false });
  }

  renderLabel() {
    const { label } = this.props;
    const { hideLabel } = this.state;

    if (hideLabel) {
      return (<div className="empty-block" />);
    }

    return (<div className="text-left form-input-label">{label}</div>);
  }

  render() {
    const {
      name,
      placeholder,
      getRef,
      isRequired,
    } = this.props;

    if (getRef) {
      getRef(this.input);
    }

    return (
      <div className="w-100 form-input-block">
        <div className="pl-3 pr-3 pt-1 pb-1 form-input-container">
          {this.renderLabel()}
          <input
            ref={this.input}
            onChange={this._onChange}
            name={name}
            className="form-input w-100"
            type="text"
            placeholder={placeholder}
            required={isRequired}
          />
        </div>
      </div>
    );
  }
}

export default FormInput;
